import { render, staticRenderFns } from "./AccountDeletionModal.vue?vue&type=template&id=063da718"
import script from "./AccountDeletionModal.vue?vue&type=script&lang=js"
export * from "./AccountDeletionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports